<script>
export default {
  name: 'BadgeFilter',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <span id="badge-dismiss-dark" class="inline-flex items-center px-2 py-1 me-2 text-sm font-medium text-white bg-primary-300 rounded">
    {{ item.value }}
    <button @click="emitter.emit('drop-filter', item.id)" class="inline-flex items-center p-1 ms-2 text-sm text-white bg-transparent rounded-sm hover:bg-primary-800 hover:text-white">
      <svg class="w-2 h-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
      </svg>
      <span class="sr-only">
        Remove badge
      </span>
    </button>
  </span>
</template>
